import React, { Component } from 'react';
import { showSearch } from '../redux/modules/search';
import { connect } from 'react-redux';

@connect(
  () => ({}),
  { showSearch }
)
class ShowSearch extends Component {
  static fetchData({ dispatch }) {
    return dispatch(showSearch(true));
  }

  componentWillUnmount() {
    this.props.showSearch(false);
  }

  render() {
    return React.Children.only(this.props.children);
  }
}

export default ShowSearch;
